import { Either } from 'src/utils/either';

import { httpResponseHandler } from 'src/http/http-response-handler';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';
import { Partner } from 'src/types/partnes';

export class PartnersRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getPartners(
    params?: any
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `partners/external/all`,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getCompanies(
    params?: any
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `partners/external/all-companies`,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getPartnerById(id: string) {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `partners/external/find/${id}`,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async create(
    body: Partner
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `partners/external/create`,
      body,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async update(
    body: any
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: `partners/external/update`,
      body,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }
}
